<template>
  <li
    class="app-column-toggle"
    :class="{ disabled: disabled, 'is-on': active }"
  >
    <a
      class="!d-flex icon-link"
      :class="{ 'has-submenu': hasSubmenu }"
      @click.prevent.stop="onClick"
    >
      <slot></slot>
      <div
        v-if="hasSubmenu"
        class="d-flex ml-auto"
      >
        <i class="hi hi-right hi-10 text-grey" />
      </div>
    </a>
  </li>
</template>

<script>
export default {
  name: 'AppToggleDropdownItem',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasSubmenu: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  methods: {
    onClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
